import script from "./RulesDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./RulesDialog.vue?vue&type=script&setup=true&lang=ts"

import "./RulesDialog.vue?vue&type=style&index=0&id=0de44d1c&scoped=true&lang=css"

import exportComponent from "K:\\VoionContaract\\voion.contaract.clients\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0de44d1c"]])

export default __exports__